import { Component, OnInit } from '@angular/core';
import { PlanService } from '../../landing/services/plan.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { UserSelectedPlan } from 'src/app/Enum/Enum';
import 'jquery';
import * as $ from 'jquery';
import { PlanSubscriptionsVM } from 'src/app/models/PlanSubcriptionVM';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Modal } from 'bootstrap';

declare var paypal;
@Component({
  selector: 'app-planselection',
  templateUrl: './planselection.component.html',
  styleUrls: ['./planselection.component.scss']
})

export class PlanselectionComponent implements OnInit {
  searchCategories: any;
  planData: any;
  userDetailsId: number;
  userRoleId: number;
  selectedPlan: number;
  paypalplanId: string;
  plancost: number;
  basic: boolean = false;
  advanced: boolean = false;
  pro: boolean = false;
  proPlus: boolean = false;
  elite: boolean = false;
  currentUser: any;
  preselectedPlanName: string;
  planForm = this.fb.group({
    selectedPlan: ['', Validators.required]
  });
  planId: string;
  public ClientID = environment.clientID;

  constructor(private planService: PlanService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute) { }

  private loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = scriptUrl
      scriptElement.onload = resolve
      document.body.appendChild(scriptElement)
    })
  }

  ngOnInit() {

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null && this.currentUser != undefined && this.currentUser.usersDetailsVM != null) {
      this.userDetailsId = this.currentUser.usersDetailsVM.id
      this.userRoleId = this.currentUser.usersDetailsVM.userRole;

      this.selectedPlan = this.currentUser.usersDetailsVM.planId;
    }

    this.route.queryParams.subscribe(params => {
      this.preselectedPlanName = params['plan'];
    });

    this.getPlansSearchCategory();
  }

  getPlansSearchCategory() {
    this.planService.getPlansSearchCategory().subscribe((response: any) => {
      if (response != null && response.content != null) {
        if (response.content.planData != null && response.content.planData.length > 0) {
          this.planData = response.content.planData;
          if (this.selectedPlan && this.selectedPlan > 0) {
            this.planForm.controls.selectedPlan.setValue(this.selectedPlan.toString());
          }
          this.planId = this.route.snapshot.paramMap.get("planId");
          if (this.planId && this.planId != "1") {
            this.planForm.controls.selectedPlan.setValue(this.planId);
            var fiterplandata = this.planData.filter(x => x.id == this.planId);
            this.paypalplanId = fiterplandata[0].paypalPlanId;
            this.plancost = fiterplandata[0].planCost;
            if (this.plancost > 0) {
              this.loadbuttons();
            }
          }
          response.content.planData.forEach(element => {
            if (element != null) {
              if (element.planName == 'Basic') {
                this.basic = true;
              }
              if (element.planName == 'Advanced') {
                this.advanced = true;
              }
              if (element.planName == 'Pro') {
                this.pro = true;
              }
              if (element.planName == 'Pro+') {
                this.proPlus = true;
              }
              if (element.planName == 'Elite') {
                this.elite = true;
              }
            }
          });
          if (this.selectedPlan && this.selectedPlan > 0) {
            this.planForm.controls.selectedPlan.setValue(this.selectedPlan.toString());
          }
        }
        if (response.content.planData != null && response.content.searchCategory.length > 0) {
          this.searchCategories = response.content.searchCategory;
          this.searchCategories = response.content.searchCategory.filter(item => item.name?.toLowerCase() !== 'analytics');
        }
      } else {

      }

      if (this.preselectedPlanName) {
        const matchedPlan = this.planData.find(p =>
          p.planName?.toLowerCase() === this.preselectedPlanName.toLowerCase()
        );
        if (matchedPlan) {
          this.planForm.controls.selectedPlan.setValue(matchedPlan.id.toString());
          this.paypalplanId = matchedPlan.paypalPlanId;
          this.plancost = matchedPlan.planCost;
        }
      }
    });
  }

  OnPlanSelection() {
    if (this.planForm.invalid) {
      this.toastr.warning('Please select at least one plan.');
    }
    else if (!this.userDetailsId) {
      this.router.navigate(['/signup', { planId: this.planForm.value.selectedPlan }]);
    }
    else {
      var data: any = this.planForm.value;
      // if(data.selectedPlan != 1)
      // {
      //   if(data.selectedPlan == this.selectedPlan && this.currentUser.usersDetailsVM.isPlanExpiried != true)
      //   {
      //   this.toastr.warning('This Plan Is Already Active. Please Select Another Plan');
      //   return;
      //   }
      // }
      ///console.log('palndata',this.planData);
      if (this.userDetailsId > 0 && data.selectedPlan > 0) {
        var fiterplandata = this.planData.filter(x => x.id == data.selectedPlan);
        this.paypalplanId = fiterplandata[0].paypalPlanId;

        // commented this as trial plans are being removed as free searches are already given without any plan
        // if (this.currentUser.usersDetailsVM.isNewUser == false) {
        //   this.paypalplanId = fiterplandata[0].paypalPlanId;
        // }
        // else {
        //   this.paypalplanId = fiterplandata[0].paypalPlanIdForFirsttimeuser;
        // }
        this.plancost = fiterplandata[0].planCost;
        let details = null;
        if (this.plancost > 0) {
          this.loadbuttons();
        }
        else
          this.onSubmit(details);
      }
    }
  }

  loadbuttons() {
    const self = this;
    self.spinner.show();

    const modalEl = document.querySelector('.add-paymetpopup') as HTMLElement;
    if (!modalEl) {
      this.spinner.hide();
      return;
    }
    const modal = Modal.getOrCreateInstance(modalEl);
    modal.show();
    // $("#openModalButton").click();

    ///sandboxclientId = Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI
    // Live  this.loadExternalScript("https://www.paypal.com/sdk/js?client-id=Ae2QVIm8vNV_sSdN8k6Cwjd6bZX1hrO51LX1bB3WKMK-WaPrk7bPp1cSmHVNL3bSlbZywd5N8qrEBl_K&vault=true").then(() => {
    // var key = "Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI&vault=true";
    //this.loadExternalScript("https://www.sandbox.paypal.com/sdk/js?client-id=AQFU3orUCznBt2wUjNjCZj9HuwOdFgKw_ix81eCzhFiJiJt9MuPYRwSI1qGynu7j7YcOzd-eeuhKtOYO&vault=true&intent=subscription&components=buttons").then(() => {

      this.loadExternalScript(`https://www.paypal.com/sdk/js?client-id=${this.ClientID}&vault=true&intent=subscription&components=buttons`).then(() => {
      self.spinner.hide();
      paypal.Buttons({
        createSubscription: (data, actions) => {
          return actions.subscription.create({
            plan_id: this.paypalplanId
            // plan_id: 'P-39P00279K5207252MNEOD4AI'  --sandbox plan id for testing
          });
        },
        onApprove: (data, actions) => {
          this.spinner.show();
          modal.hide();

          return actions.subscription.get().then((details) => {
            this.onSubmit(details);
          }).catch((err) => {
            this.toastr.error('Failed to get subscription details.');
            this.spinner.hide();
          });
        },
        onError: (err) => {
          this.toastr.error('Something went wrong with PayPal. Please try again.');
          this.spinner.hide();
        }
      }).render('#paypal-button-container');
    });
  }

  onSubmit(details: any) {
    var data: any = this.planForm.value;
    if (this.userDetailsId > 0 && data.selectedPlan > 0) {
      let subcriptonmodel = new PlanSubscriptionsVM();
      var currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (details != null) {
        subcriptonmodel.CreatedBy = currentUser.usersDetailsVM.userId;
        subcriptonmodel.FullName = details.subscriber.name.given_name + ' ' + details.subscriber.name.surname;
        subcriptonmodel.PlanId = details.plan_id;
        subcriptonmodel.status = details.status;
        subcriptonmodel.status_update_time = details.status_update_time;
        subcriptonmodel.SubcriptionId = details.id;
        subcriptonmodel.UpdatedDate = details.update_time;
        subcriptonmodel.UserId = currentUser.usersDetailsVM.userId;
        subcriptonmodel.address_line_1 = details.subscriber.shipping_address.address.address_line_1;
        subcriptonmodel.admin_area_2 = details.subscriber.shipping_address.address.admin_area_2;
        subcriptonmodel.country_code = details.subscriber.shipping_address.address.country_code;
        subcriptonmodel.postal_code = details.subscriber.shipping_address.address.postal_code;
        subcriptonmodel.start_time = details.start_time;
        subcriptonmodel.status = details.status;
        subcriptonmodel.email_address = details.subscriber.email_address;
        subcriptonmodel.payer_id = details.subscriber.payer_id;
        subcriptonmodel.next_billing_time = details.billing_info.next_billing_time;
        subcriptonmodel.final_payment_time = details.billing_info.final_payment_time;
        //subcriptonmodel.failed_payments_count = parseInt(details.billing_info.failed_payments_count);
      }
      subcriptonmodel.userDetailsId = this.userDetailsId;
      subcriptonmodel.selectedPlan = parseInt(data.selectedPlan);

      this.planService.MapUserToPlan(subcriptonmodel).subscribe((response: any) => {
        if (response != null && response.isSuccess == true && response.content != null) {
          if (currentUser != null && currentUser.usersDetailsVM != null) {
            currentUser.usersDetailsVM.planId = response.content.planId;
            currentUser.usersDetailsVM.planName = response.content.planName;
            currentUser.usersDetailsVM.planDuration = response.content.planDuration;
            currentUser.usersDetailsVM.isPlanExpiried = response.content.isPlanExpiried;
            currentUser.usersDetailsVM.planPermission = response.content.planPermission;
            currentUser.status = response.content.status;
          };
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          this.spinner.hide();
          this.toastr.success('Your subscription has been activated successfully!', '', {
            positionClass: 'toast-top-full-width'
          });
          // this.router.navigate(['/']);
        } else {
          this.spinner.hide();
          this.toastr.warning(response.message);
        }
      });
    }
  }
}
